import { useMemo } from 'react';
import './waiting-indicator-circle.scss';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import classNames from 'classnames';

export default function WaitingIndicatorCircle({
  fill = '',
  size,
  fillSpace = false,
  minHeight,
  transparentFill = false,
}: {
  fill?: string;
  size?: number;
  fillSpace?: boolean;
  minHeight?: number | string;

  transparentFill?: boolean;
}): JSX.Element {
  const svg = useMemo(() => {
    return <Icon name={ICONS.LOADER} size={size} color={classNames('waiting-indicator-circle', fill)} />;
  }, [fill, size]);

  return fillSpace ? (
    <div
      className="waiting-indicator-circle-fill-space"
      style={{ minHeight, backgroundColor: transparentFill ? 'transparent' : undefined }}
    >
      {svg}
    </div>
  ) : (
    <div style={{ height: size, width: size }}>{svg}</div>
  );
}
